'use strict'

// One cockpit-row "your day" status tile for the home page's Zone-1 strip
// (open tickets, next event, online now, unread). Sits in a 4-cell grid
// directly under the greeting — replaces the empty space that used to live
// there. Each tile is a clickable Link routing into its app, with a big
// primary value, a label (optionally prefixed by a live dot) and a one-line
// sub-caption. Dense by design — think cockpit, not launcher tile.
//
// Per-card state (fed by main.js's `_dayCockpit` via childrenAs: 'state'):
//   { label, value, sub, route, dot? }
// `dot` is a design-system color name (`'green' | 'orange' | 'blue' | …`);
// when set, a small filled circle renders next to the label as a live
// indicator. Falsy = no dot (resting / empty state).
export const DayCard = {
  tag: 'button',
  type: 'button',
  flow: 'y',
  gap: 'Z',
  round: 'radiusCard',
  padding: 'B',
  textAlign: 'left',
  cursor: 'pointer',
  color: 'title',
  background: 'overlay',
  border: 'none',
  transition: '160ms defaultBezier background, 160ms defaultBezier transform',
  ':hover': { theme: 'dialog', transform: 'translateY(-1px)' },

  onClick: (e, el, s) => {
    if (s.route) el.router(s.route, el.getRoot())
  },

  Head: {
    flow: 'x',
    gap: 'Z',
    align: 'center',
    Dot: {
      hide: (el, s) => !s.dot,
      width: 'Y',
      height: 'Y',
      minWidth: 'Y',
      round: '50%',
      background: (el, s) => s.dot || 'green'
    },
    Label: {
      tag: 'span',
      fontSize: 'Y2',
      fontWeight: '700',
      textTransform: 'uppercase',
      letterSpacing: '0.04em',
      color: 'caption',
      text: (el, s) => s.label
    }
  },

  Value: {
    tag: 'span',
    fontSize: 'C',
    fontWeight: '700',
    lineHeight: '1.05',
    color: 'title',
    text: (el, s) => s.value
  },

  Sub: {
    tag: 'p',
    margin: '0',
    fontSize: 'Y',
    lineHeight: '1.4',
    color: 'caption',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    text: (el, s) => s.sub
  }
}
